import React, {Component} from 'react'
import {Icon, Modal, Tabs} from 'antd'
import ClaimsForm from './ClaimsForm'
import ClaimItemModal from './ClaimItems/ClaimItemModal'
import ClaimItemsList from './ClaimItems/ClaimItemsList'
import {get} from 'lodash'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import FooterButton from '../../../elements/Buttons/FooterButtons'
import {CLAIM_MANAGER} from '../../../components/People/Claims/ClaimsCont'
import propTypes from 'prop-types'

const {TabPane} = Tabs

class ClaimModal extends Component {
  render() {
    const {
      visible,
      modalType,
      submitting,
      option,
      fetchingClaim,
      onCancelClaim,
      removing,
      remove,
      submit,
      update,
      formRef,
      claim,
    } = this.props
    return (
      <Modal
        title={'Claim'}
        visible={visible}
        destroyOnClose={true}
        confirmLoading={submitting}
        onCancel={onCancelClaim}
        width={'77%'}
        footer={
          option === CLAIM_MANAGER ? null : (
            <FooterButton
              remove={remove}
              removing={removing}
              submit={submit}
              submitting={submitting}
              update={update}
              title={'Claim'}
              isEdit={modalType === 'edit'}
              isNew={modalType === 'new'}
              visible={
                modalType === 'new' ||
                claim.status === 'Submitted' ||
                claim.status === 'Draft'
              }
            />
          )
        }>
        <Tabs defaultActiveKey={get(this.props, 'location.hash') || '#details'}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle" />
                Details
              </span>
            }
            key="#details">
            <ClaimsForm ref={formRef} {...this.props} loading={fetchingClaim} />
            <ClaimItemModal {...this.props} />
            <ClaimItemsList {...this.props} />
          </TabPane>
          <TabPane
            disabled={modalType === 'new'}
            tab={
              <span>
                <Icon type="copy" />
                Document
              </span>
            }
            key="#document">
            <DocumentsCont
              editable={claim.status === 'Submitted'}
              footer={false}
              category={false}
              owner={claim}
            />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

ClaimModal.propTypes = {
  visible: propTypes.bool,
  modalType: propTypes.string,
  submitting: propTypes.bool,
  option: propTypes.string,
  fetchingClaim: propTypes.bool,
  onCancelClaim: propTypes.func,
  removing: propTypes.bool,
  remove: propTypes.func,
  submit: propTypes.func,
  update: propTypes.func,
  formRef: propTypes.object,
  claim: propTypes.object,
  actions: propTypes.array.isRequired,
}
ClaimModal.defaultProps = {
  visible: false,
  modalType: '',
  submitting: false,
  option: '',
  fetchingClaim: false,
  onCancelClaim: () => {},
  removing: false,
  remove: () => {},
  submit: () => {},
  update: () => {},
  formRef: null,
  claim: {},
  actions: [],
}

export default ClaimModal
